import { createFileRoute } from "@tanstack/react-router"
import { EvaluationPage } from "@/evaluation"
import type { EvaluationTab } from "@/common"
import type { Uuid } from "@/utils"

export const Route = createFileRoute("/(user)/t/$tenantSlug/evaluations/$id")({
  component: RouteComponent,
  validateSearch: (search) =>
    search as {
      revision?: string
      batchId?: Uuid
      runId?: Uuid
      evaluationTab?: EvaluationTab
    },
})

function RouteComponent() {
  const { evaluationTab, batchId } = Route.useSearch()

  return <EvaluationPage evaluationTab={evaluationTab} batchId={batchId} />
}
